import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from './UserProfile.module.css';
import EditingContext from './EditingContext';

const cx = classNames.bind(styles);

function EditableNumber({
  user, className, value, placeholder,
}) {
  const { editing, setEditing } = useContext(EditingContext);

  return (
    <input
      type="number"
      pattern="[0-9]*"
      step="0.1"
      inputMode="decimal"
      className={cx('numberEditable', className)}
      placeholder={placeholder}
      value={editing === null ? user?.[value] || '' : editing?.[value] || ''}
      disabled={editing === null}
      onChange={(evt) => setEditing({ ...editing, [value]: evt.target.value })}
    />
  );
}

EditableNumber.propTypes = {
  value: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  className: PropTypes.string,
  placeholder: PropTypes.string,
};

EditableNumber.defaultProps = {
  placeholder: '',
  className: '',
};

export default EditableNumber;
